import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class BarTender_ds_get_azure_blob_file_contentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { navigation_path?: string, recursive?: boolean, use_explicit_file_path?: boolean, $top?: number, $skip?: number }): Promise<{ result?: { Name?: string, Type?: string, Path?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/BarTender/datasources/ds_get_azure_blob_file_content/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { navigation_path?: string, recursive?: boolean, use_explicit_file_path?: boolean, $keys: string[] }): Promise<{ result?: { Name?: string, Type?: string, Path?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarTender/datasources/ds_get_azure_blob_file_content/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      navigation_path?: string, recursive?: boolean, use_explicit_file_path?: boolean    }) {
      return false;
    }
}
